// extracted by mini-css-extract-plugin
export default {"container":"BOMExportButton__container--EnB7x","spacer":"BOMExportButton__spacer--tKucm","item":"BOMExportButton__item--GO0N5","button":"BOMExportButton__button--quhei"};